<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-item :label="$t('label.company')"  :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled type="list" v-decorator="['companyCode']" :trigger-change="true" dictCode="" :placeholder="$t('label.pleaseSelectCompany')"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.farms')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled  type="list" v-decorator="['farmCode']" :trigger-change="true" dictCode="" :placeholder="$t('label.pleaseSelectFarms')"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.batch')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input disabled v-decorator="['breedBatchCode']" placeholder="请输入批次"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.contractCode')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input disabled v-decorator="['conCode']" :placeholder="$t('label.pleaseEnterTheContractCode')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="预估上市时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date disabled placeholder="请选择预估上市时间" v-decorator="['planMarketTime']" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="实际上市时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date  placeholder="请选择实际上市时间" v-decorator="['actMarketTime']" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="预估上市数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['planMarketQty']" placeholder="请输入实际出栏数量" style="width: 84%"/>{{ $t('label.feather') }}
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="实际出栏数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number  v-decorator="['actMarketQty']" placeholder="请输入实际出栏数量" style="width: 84%"/>{{ $t('label.feather') }}
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="预估上市重量" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['planMarketWeight']" placeholder="请输入预估上市重量" style="width: 84%"/> kg
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="实际上市重量" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['actMarketWeight']" placeholder="请输入实际上市重量" style="width: 84%"/> kg
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="存栏量" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number  disabled v-decorator="['stockAmount']" placeholder="请输入存栏量" style="width: 84%"/>{{ $t('label.feather') }}
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">{{$t('button.submit')}}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@comp/jeecg/JFormContainer'
  import JDate from '@comp/jeecg/JDate'
  import JDictSelectTag from "@comp/dict/JDictSelectTag"

  export default {
    name: 'EfsMktPlanForm',
    components: {
      JFormContainer,
      JDate,
      JDictSelectTag,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/marketPlan/efsMktPlan/add",
          edit: "/marketPlan/efsMktPlan/edit",
          queryById: "/marketPlan/efsMktPlan/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'companyCode','farmCode','breedBatchCode','conCode','stockAmount','planMarketTime','actMarketTime','planMarketQty','actMarketQty','planMarketWeight','actMarketWeight'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'companyCode','farmCode','breedBatchCode','conCode','stockAmount','planMarketTime','actMarketTime','planMarketQty','actMarketQty','planMarketWeight','actMarketWeight'))
      },
    }
  }
</script>